<div class="validation-panel">
  <div class="validation-header">
    <div>
      <h3>Validation Logs</h3>
      <span nz-typography>File format validation and encryption validation will be logged here</span>
    </div>
    <nz-tag *ngIf="reports.length > 0" class="report-count-tag">
      {{ reports.length }} {{ reports.length === 1 ? 'report' : 'reports' }}
    </nz-tag>
  </div>

  <div class="empty-state" *ngIf="!hasLogs">
    <span nz-icon nzType="file-search" nzTheme="outline"></span>
    <p nz-typography>No validation logs yet.</p>
  </div>

  <div class="validation-result" *ngIf="fallbackText">
    <p nz-typography>{{ fallbackText }}</p>
  </div>

  <div class="validation-report" *ngFor="let report of reports">
    <div class="report-topline">
      <div class="report-title">
        <span
          nz-icon
          [nzType]="report.statusTone === 'success' ? 'check-circle' : 'close-circle'"
          [ngClass]="report.statusTone === 'success' ? 'success-icon' : 'error-icon'"
          nzTheme="fill"
        ></span>
        <div>
          <h4>{{ report.fileName }}</h4>
        </div>
      </div>
      <nz-tag [ngClass]="report.statusTone === 'success' ? 'status-success' : 'status-error'">
        {{ report.status }}
      </nz-tag>
    </div>

    <div class="metric-grid">
      <div class="metric-tile">
        <span>Total Rows</span>
        <strong>{{ report.summary.totalRows ?? 0 }}</strong>
      </div>
      <div class="metric-tile success">
        <span>Valid Rows</span>
        <strong>{{ report.summary.validRows ?? 0 }}</strong>
      </div>
      <div class="metric-tile error">
        <span>Invalid Rows</span>
        <strong>{{ report.summary.invalidRows ?? 0 }}</strong>
      </div>
      <div class="metric-tile error">
        <span>Total Errors</span>
        <strong>{{ report.totalErrors }}</strong>
      </div>
    </div>

    <div class="columns-overview">
      <div class="section-heading">
        <h5>Column Coverage</h5>
        <span>{{ report.matchedColumns.length }} of {{ report.totalColumns }} columns matched</span>
      </div>
      <nz-progress [nzPercent]="report.matchPercent" [nzShowInfo]="false"></nz-progress>

      <div class="column-groups">
        <div class="column-group matched">
          <div class="group-title">
            <span nz-icon nzType="check-circle" nzTheme="outline"></span>
            Matched
          </div>
          <div class="tag-list">
            <nz-tag *ngFor="let column of report.matchedColumns">{{ column }}</nz-tag>
            <span class="muted" *ngIf="report.matchedColumns.length === 0">None</span>
          </div>
        </div>

        <div class="column-group missing">
          <div class="group-title">
            <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
            Missing
          </div>
          <div class="tag-list">
            <nz-tag *ngFor="let column of report.missingColumns">{{ column }}</nz-tag>
            <span class="muted" *ngIf="report.missingColumns.length === 0">None</span>
          </div>
        </div>

        <div class="column-group extra">
          <div class="group-title">
            <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
            Extra
          </div>
          <div class="tag-list">
            <nz-tag *ngFor="let column of report.extraColumns">{{ column }}</nz-tag>
            <span class="muted" *ngIf="report.extraColumns.length === 0">None</span>
          </div>
        </div>
      </div>
    </div>

    <div class="column-error-section" *ngIf="report.columnErrors.length > 0">
      <div class="section-heading">
        <h5>Column Errors</h5>
        <span>{{ report.columnErrors.length }} columns impacted</span>
      </div>

      <nz-table
        class="column-errors-table"
        [nzData]="report.columnErrors"
        [nzBordered]="true"
        [nzShowPagination]="false"
        nzSize="small"
      >
        <thead>
          <tr>
            <th>Column</th>
            <th>Error Count</th>
            <th>Error Types</th>
            <th>Sample Values</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let columnError of report.columnErrors">
            <td class="column-name">
              <strong>{{ columnError.column }}</strong>
            </td>
            <td class="error-count">{{ columnError.errorCount }}</td>
            <td>
              <div class="tag-list compact">
                <nz-tag *ngFor="let errorType of columnError.errorTypes">{{ errorType }}</nz-tag>
              </div>
            </td>
            <td>
              <div class="sample-list">
                <code *ngFor="let sample of columnError.sampleValues">{{ sample === '' ? '(blank)' : sample }}</code>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <details class="raw-response">
      <summary>Raw response</summary>
      <pre>{{ report.rawResponse }}</pre>
    </details>
  </div>
</div>
